<div *ngIf="publicWishlist">
    <div class="_flex _flex-col _items-start _justify-center sm-max:_w-full sm-max:_max-w-600px _mx-auto">
        <div class="md:_container _mx-auto _w-full _py-2 _px-4 md:_px-2">
            <nav>
                <div class="_flex _flex-row _justify-center _py-4"
                    [ngClass]="!companyLogo ? '_h-auto' : '_h-30'">
                    <img 
                        *ngIf="companyLogo"
                        class="_h-full _w-auto"
                        app-imagekit
                        [source]="companyLogo" 
                        width="auto" 
                        height="180" 
                        transform="tr:h-180,fo-auto">
                    <h1 *ngIf="!companyLogo" class="_h2">{{companyName}}</h1>
                </div>
            </nav>

            <h2 class="_text-h4-m md:_text-h2 _my-10">{{ "wishlist" | businessName | upperCaseFirst}}: {{publicWishlist.name}}</h2>
            
            <div class="_grid _grid-cols-1 sm:_grid-cols-2 _grid-flow-row _auto-rows-max _gap-x-4 _gap-y-10 _pb-10">
                <div *ngFor="let wish of publicWishlist.wishes" class="_panel _p-2">
                    <div class="_flex _flex-col _p-2 _mb-2">
                        <app-feature-image 
                            [images]="wish.searchListing.summary.listingPhotos ? wish.searchListing.summary.listingPhotos : wish.searchListing.summary.photos" 
                            (imageClickEvent)="viewPhotos(wish.searchListing)">
                            <div class="photo-count _absolute">
                                <app-flok-badge (click)="viewPhotos(wish.searchListing)">
                                    <div class="_flex _flex-row _items-center _justify-center _gap-1 _px-2">
                                        <i class="fa-sharp fa-light fa-grid"></i>
                                        <a class="_text-sm">Show all photos</a>
                                    </div>
                                </app-flok-badge>
                            </div>
                        </app-feature-image>
                        <div class="info _flex _flex-col _justify-start _items-center _pt-6">
                            <h5>{{wish.searchListing.summary.title | slice:0:40}}</h5>
                            <h6>{{wish.searchListing.summary.subtitle | slice:0:40}}</h6>
                            <div>
                                <ng-container *ngIf="wish.searchListing.summary.city">
                                    <span>{{wish.searchListing.summary.city}}, </span>
                                </ng-container>
                                <app-country-code [countryCode]="wish.searchListing.summary.countryCode"></app-country-code>
                            </div>
<!--
                            <div class="_flex _gap-4 _my-4">
                                <ng-container *ngFor="let decidingFactor of wish.searchListing.summary.decidingFactors?.primaryDecidingFactors">
                                    <app-listing-deciding-factor 
                                        [titleOnly]="true" 
                                        [decidingFactor]="decidingFactor">
                                    </app-listing-deciding-factor>
                                </ng-container>
                            </div>
-->

                            <div class="_border _panel-accented _py-4 _gap-4 _my-4">
                                <div class="_flex _flex-col _items-center _text-lg _mb-2" *ngIf="wish.guestCounts">
                                    <div class="_flex _gap-2 _items-center ">
                                        <app-listing-guest-details [guestCounts]="wish.guestCounts || []"></app-listing-guest-details>
                                    </div>
                                </div>
                                <div class="_flex _flex-col _items-center _text-lg" *ngIf="wish.travelDates">
                                    <span class="_mb-2 _text-sm">Travel Dates</span>
                                    <div class="_flex _gap-2 _items-center ">
                                        <span class="_font-bold">{{wish.travelDates.checkin | date:'dd MMM YYYY'}}</span>
                                        <i class="fa-light fa-arrow-right _text-sm"></i>
                                        <span class="_font-bold">{{wish.travelDates.checkout | date:'dd MMM YYYY'}}</span>
                                    </div>
                                </div>

                                <!-- Price display with modification support -->
                                <span class="_text-lg _text-center" *ngIf="!wish.searchListing.fees">
                                    <div class="_mb-2 _text-sm">Best available rate</div>
                                    <div *ngIf="wish.priceModification?.adjustedBookingFee; else showOriginalPriceRange">
                                        <span class="_font-bold _pill _mb-2">
                                            <app-booking-price [fees]="{ bookingFee: wish.priceModification.adjustedBookingFee }"></app-booking-price>
                                        </span>
                                    </div>
                                    <ng-template #showOriginalPriceRange>
                                        <span class="_font-bold _pill _mb-2">
                                            <app-booking-price [fees]="wish.searchListing.priceRange.lowest"></app-booking-price>
                                        </span>
                                    </ng-template>
                                    <div class="_text-sm">per night</div>
                                </span>
                                <span class="_text-lg _text-center" *ngIf="wish.searchListing.fees">
                                    <div class="_mb-2 _text-sm">Price</div>
                                    <div *ngIf="wish.priceModification?.adjustedBookingFee; else showOriginalFees">
                                        <span class="_font-bold _pill">
                                            <app-booking-price [fees]="{ bookingFee: wish.priceModification.adjustedBookingFee }"></app-booking-price>
                                        </span>
                                    </div>
                                    <ng-template #showOriginalFees>
                                        <span class="_font-bold _pill">
                                            <app-booking-price [fees]="wish.searchListing.fees"></app-booking-price>
                                        </span>
                                    </ng-template>
                                </span>
                            </div>
                            <div class="_flex _flex-col xs:_flex-row _gap-2 _mt-6">
                                <button class="_button-secondary" 
                                    (click)="openPropertyDetails(wish.searchListing.summary.title, wish.searchListing.summary.assetDescription)">
                                    <i class="fa-sharp fa-light fa-eye _mr-1"></i>
                                    Hotel Description</button>
                                <button *ngIf="wish.searchListing.summary.subtitle" 
                                    class="_button-secondary" 
                                    (click)="openPropertyDetails(wish.searchListing.summary.subtitle, wish.searchListing.summary.listingDescription)">
                                    <i class="fa-sharp fa-light fa-eye _mr-1"></i>
                                    Suite Description
                                </button>    
                            </div>
                            <a class="_button-primary _mt-4 _text-md" 
                                target="_blank" 
                                [href]="'/public-listing/' + wish.searchListing.listingId + '?currency=' + currency + (companyLogo ? '&company_logo=' + companyLogo : '')">
                                <i class="fa-sharp fa-light fa-arrow-up-right-from-square _mr-1"></i>
                                    View listing page
                             </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
